import { deepMemoized } from './helpers';
import { wrappedAnalytics } from './setConfiguration';
let previousInternalSearchProps;
export function sendInternalSearch(props) {
  const {
    type,
    keyword,
    page,
    click_rank
  } = props;
  const formattedInternalSearchProps = deepMemoized({
    ise_keyword: keyword,
    ise_page: page,
    ise_click_rank: click_rank
  });
  if (!previousInternalSearchProps || formattedInternalSearchProps !== previousInternalSearchProps) {
    previousInternalSearchProps = formattedInternalSearchProps;
    wrappedAnalytics.sendEvent(`internal_search_result.${type}`, formattedInternalSearchProps);
  }
}